// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3eYcg{width:440px;width:44rem}", ""]);
// Exports
exports.locals = {
	"info": "_3eYcg"
};
module.exports = exports;
